<template>
  <div class="interview-format-details">
    <div class="d-flex justify-space-between align-center">
      <div class="d-flex">
        <div class="d-flex align-center">
          <v-icon class="interview-format-icon" large>
            mdi-clipboard-text-outline
          </v-icon>
          <h2 class="ml-2">
            {{ interviewFormat.interviewName }} ({{ interviewFormat.duration }}
            mins)
          </h2>
        </div>
      </div>
    </div>
    <div>
      <div
        class="d-flex justify-space-between mt-4"
        :class="{ 'flex-column': isMobile }"
      >
        <div class="pre-line-text">
          <h3 class="mt-1 mb-2">Details for Candidate</h3>
          <div
            class="rich-text-container"
            v-html="interviewFormat.candidateDetails"
          />
        </div>
        <EditInterviewFormatBasicDetailsAction
          :interviewFormat="interviewFormat"
        />
      </div>
      <div class="pre-line-text my-3">
        <h3 class="mb-2">Details for Interviewers</h3>
        <div v-html="interviewFormat.interviewerDetails" />
      </div>
      <div class="interview-format-details__dividing-line mb-4"></div>
      <div
        class="d-flex justify-space-between"
        :class="{ 'flex-column': isMobile }"
      >
        <h3 class="mb-2">Candidate Self-Schedule</h3>
        <EditSelfScheduleInterviewFormatAction
          :interviewFormat="interviewFormat"
        />
      </div>
      <InterviewFormatBasicInfo :interviewFormat="interviewFormat" />
    </div>
  </div>
</template>

<script>
import pluralize from "pluralize";
import EditSelfScheduleInterviewFormatAction from "@/views/bookings/BookingInterviews/components/actions/EditSelfScheduleInterviewFormatAction";
import EditInterviewFormatBasicDetailsAction from "@/views/bookings/BookingInterviews/components/actions/EditInterviewFormatBasicDetailsAction";
import InterviewFormatBasicInfo from "@/views/bookings/BookingInterviews/components/InterviewFormatBasicInfo";

export default {
  props: {
    interviewFormat: {
      type: Object,
      required: true
    }
  },
  components: {
    EditSelfScheduleInterviewFormatAction,
    EditInterviewFormatBasicDetailsAction,
    InterviewFormatBasicInfo
  },
  methods: {
    pluralize
  }
};
</script>

<style lang="scss">
.interview-format-details {
  padding-bottom: 25px;

  .interview-format-icon {
    margin-right: 5px;
    padding: 5px;
    background-color: rgba(#80ff00, 0.15);
    color: $black !important;
    border-radius: 4px;
    width: 60px;
    height: 60px;
  }
  .interview-format-section-title {
    font-size: 21px;
    font-weight: bold;
  }

  &:not(:last-child) {
    border-bottom: 1px solid $default-line;
  }

  &__dividing-line {
    width: 100%;
    border-bottom: 1px solid $secondary-line;
  }
}
</style>
